import React from "react";
//Limitless imports
import { useCustomerMessageContext } from "../customer-message/CustomerMessageContext";
import { submitSuggestedAnswerFeedback } from "../../apis/customer-message-api/CustomerMessageAPI";
import { MESSAGE_STATE_NEW } from "../../utils";
const INITIAL_STATE = {
  suggestedAnswerSelection: null,
  clearSuggestedAnswers: false,
  dialoguesVisibility: true
};
export const useCustomerSuggestedAnswers = () => {
  const {
    message,
    updateMessageState,
    fetchMessage
  } = useCustomerMessageContext();
  const {
    messageId,
    accessKey
  } = message;
  const [customerSAState, setCustomerSAState] = React.useState(INITIAL_STATE);
  const selectSuggestedAnswer = dialogueId => {
    setCustomerSAState({
      ...customerSAState,
      suggestedAnswerSelection: dialogueId
    });
  };
  const updateDialogueVisiblity = isVisible => {
    setCustomerSAState({
      ...customerSAState,
      dialoguesVisibility: isVisible
    });
  };
  const submitSuggestedAnswer = callback => {
    submitSuggestedAnswerFeedback(message, customerSAState.suggestedAnswerSelection, () => {
      fetchMessage(messageId, accessKey);
      updateDialogueVisiblity(true);
      callback();
    });
  };
  const rejectSuggestedAnswer = () => {
    setCustomerSAState({
      ...customerSAState,
      clearSuggestedAnswers: true
    });

    //Wait for the SA animation to complete before making this call.
    setTimeout(() => {
      setCustomerSAState({
        ...customerSAState,
        dialoguesVisibility: true,
        clearSuggestedAnswers: true
      });
      submitSuggestedAnswerFeedback(message, null, () => {
        updateMessageState(MESSAGE_STATE_NEW);
      });
    }, 400);
  };
  return {
    customerSAState,
    selectSuggestedAnswer,
    updateDialogueVisiblity,
    submitSuggestedAnswer,
    rejectSuggestedAnswer
  };
};